import Perplexity from './Perplexity';

export default Perplexity;
